export const TRACKING_TAGS_DEFAULT_MEDIUM = 'local-listings';
export const TRACKING_TAGS_DEFAULT_CAMPAIGN = 'pluspoint';
export const TRACKING_TAGS_MAX_LENGTH = 100;
export const TRACKING_TAGS_SOURCES = ['google', 'facebook', 'local-directory'];
export const TRACKING_TAGS_STORE_CODE_SAMPLE = 'STORE-CODE';
export const TRACKING_TAG_SLUG = /^[a-z0-9]+(-[a-z0-9]+)*$/;

const PAID_MEDIUM = /cp|^ppc$|^retargeting$|^paid/;
const SHOPPING_CAMPAIGN = /(^|[^a-df-z])shop|shopping/;

export const isPaidMedium = medium => PAID_MEDIUM.test(medium || '');
export const isShoppingCampaign = campaign => SHOPPING_CAMPAIGN.test(campaign || '');

export const listingLinkPreview = ({ website, source, medium, campaign, storeCode }) => {
    const tags = [
        `utm_source=${source}`,
        `utm_medium=${encodeURIComponent(medium || TRACKING_TAGS_DEFAULT_MEDIUM)}`,
        `utm_campaign=${encodeURIComponent(campaign || TRACKING_TAGS_DEFAULT_CAMPAIGN)}`,
        ...(storeCode ? [`utm_content=${encodeURIComponent(storeCode)}`] : []),
    ];
    return `${website}${website.includes('?') ? '&' : '?'}${tags.join('&')}`;
};
